import axios from 'axios';

import { UserDto } from '@tallo/user';

import { UpdateInvestorUserDto } from '../dtos/update-investor-user.dto';

class InvestorUserService {
  async updateUser(userData: UpdateInvestorUserDto): Promise<UserDto> {
    const response = await axios.patch('investor/user', userData);
    return response.data.user as UserDto;
  }

  async updateName(name: string): Promise<UserDto> {
    return this.updateUser({ name });
  }

  async updatePhoneNumber(phoneNumber: string): Promise<UserDto> {
    return this.updateUser({ phoneNumber });
  }
}

export default new InvestorUserService();
